import { Link } from 'react-router-dom';
import { instagramUrl, useStorefrontContent } from '../../hooks/useStorefrontContent';
import './Footer.css';

export function SocialLinks() {
  const { content } = useStorefrontContent();
  const instagram = instagramUrl(content);
  return (
    <div className="social-links">
      <Link to="/stories">Blog</Link>
      {instagram && (
        <a href={instagram} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      )}
    </div>
  );
}
export default function Footer() {
  return (
    <footer className="footer">
      <a className="footer__link" href="mailto:reshamtales@gmail.com">
        Contact us
      </a>
      <SocialLinks />
    </footer>
  );
}
